const Prolastin = ({ themeColor }: { themeColor: string }) => {
  return (
    <>
      <div className="text-xl md:text-3xl font-bold">
        <span style={{ color: themeColor }}>MEDICAL BENEFITS BILLING PORTAL FOR PROVIDERS. </span>

        <p className="my-2">SITE-OF-CARE DRIVEN COPAY ASSISTANCE.</p>
      </div>

      <p className="my-2">
        If your patient’s primary payer drug claim is billed under medical benefits, you can request
        PROLASTIN®-C (alpha1-proteinase inhibitor (human) (alpha1-PI)) copay assistance using this
        portal. ​Eligible patients can receive up to $10,000 over a calendar year to cover the
        deductible, copay, and/or coinsurance for PROLASTIN.
      </p>

      <p className="my-2">
        <b>Note: </b>
        Nursing and supply costs that may be associated with the administration of the medication
        are not eligible for assistance through this program. For both medical and pharmacy
        benefits, claims must be received within 45 days of dispense date.
        <b>
          {' '}
          For medical benefits only, EOBs must also be submitted within 180 days of the date the
          claim was submitted.
        </b>
      </p>

      <p className="my-2 font-bold mt-10">ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE</p>

      <ul className="my-2 list-disc ml-10">
        <li>Commercially insured patients only</li>
        <li>Assistance available for the treatment of alpha1-antitrypsin deficiency</li>
        <li>Patient must be a US resident</li>
      </ul>

      <p className="my-2 font-bold">RESTRICTIONS</p>

      <ul className="my-2 list-disc ml-10">
        <li>
          Patients are ineligible for copay assistance if they participate in Medicare, Medicaid,
          Medigap, Veterans Affairs, Department of Defense, Tricare, or any other federal or
          state-funded programs
        </li>
      </ul>
    </>
  );
};

export default Prolastin;
